<template>
  <v-dialog
    :value="dialog"
    @click:outside="closeDialog('accept')"
    width="800"
    v-if="current && current.validations"
  >
    <v-card v-if="current">
      <v-card-title
        >Refus d'un bon de commande ({{ current.orderId
        }}{{ current.creatorTla }})</v-card-title
      >
      <v-card-text>
        <div class="body-1">
          Une fois la validation rejetée, ce bon de commande terminera le
          processus de validation.
        </div>
        <div class="body-1 mt-2">
          Un e-mail de demande de validation sera, par ailleurs, envoyé à la
          personne ayant créé ce bon de commande
        </div>
        <v-textarea
          outlined
          dense
          v-model="reason"
          label="Raison du refus"
          class="mt-3"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="submitValidation">Refuser ce bon de commande</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    reason: "",
  }),
  methods: {
    ...mapActions("dialog", ["closeDialog"]),
    ...mapActions("validations", ["submitValidationAsync"]),
    submitValidation() {
      this.submitValidationAsync({
        _id: this.current.validations.find((v) => v.status === "pending")._id,
        validator: this.selected,
        next: this.current.validations.filter((v) => !v.user).length
          ? this.current.validations.filter((v) => !v.user)[0].type
          : "accepted",
        status: "rejected",
        reason: this.reason,
      });
    },
  },
  computed: {
    ...mapState({
      dialog: (state) => state.dialog.reject.open,
      current: (state) => state.orders.current,
    }),
  },
};
</script>